import Model, { attr, belongsTo } from '@ember-data/model';
import type { Type } from '@warp-drive/core-types/symbols';
import type Flow from 'invite-sign/models/flow';

export interface IpadLocalizedMessageHtml {
  'language-code': string;
  'region-code': string | null;
  'display-name': string;
}

export interface CustomTranslations {
  message: Record<string, unknown>;
}

export default class SummaryPage extends Model {
  declare [Type]: 'summary-page';

  @belongsTo('flow', { async: false, inverse: 'summaryPage' }) declare flow: Flow | null;

  @attr('boolean') declare allowEmail: boolean;
  @attr('number') declare position: number;
  /**
   * Image URL or path. Nullable.
   */
  @attr('string') declare image: string | null;
  @attr('string') declare kind: string;
  /**
   * Optional message to display. Nullable.
   */
  @attr('string') declare message: string | null;
  @attr('string') declare messageHtml: string;
  /**
   * Optional video URL. Nullable.
   */
  @attr('string') declare videoUrl: string | null;
  /**
   * Custom translations as a plain object with a `message` key. Structure may be extended.
   */
  @attr() declare customTranslations: CustomTranslations;
  /**
   * Localized message HTMLs for iPad, typed as an array of objects with language/region/display-name.
   */
  @attr('array') declare ipadLocalizedMessageHtmls: IpadLocalizedMessageHtml[];
}
